<template>
  <v-app
    class="background-container"
    :style="
      $vuetify.breakpoint.name != 'xs' ? backgroundStyle : XSbackgroundStyle
    "
  >
    <router-view />
  </v-app>
</template>
<script>
export default {
  computed: {
    backgroundStyle() {
      return {
        // "background-image": `url(${require("@/assets/PoliceBike.jpg")})`,
        // "background-image": `url(${require("@/assets/Car_Image.jpg")})`,
        // "background-size": "cover",
        // "background-repeat": "no-repeat",
        "background-image": `url(${require("@/assets/Car_Image.jpg")})`,
        "background-size": "cover",
        "background-repeat": "no-repeat",
        "background-position": "center",
        // "background-color": "#2E4392",
      };
    },
    XSbackgroundStyle() {
      return {
        "background-size": "cover",
        "background-repeat": "no-repeat",
        "background-color": "#2E4392",
      };
    },
  },
  // mounted() {
  //   document.addEventListener("contextmenu", this.preventContextMenu);
  //   document.addEventListener("keydown", this.preventKeyShortcuts);
  // },
  // methods: {
  //   preventContextMenu(event) {
  //     event.preventDefault();
  //   },
  //   preventKeyShortcuts(event) {
  //     if (event.key === "F12") {
  //       event.preventDefault();
  //     }
  //     if (event.ctrlKey && event.shiftKey && event.key === "I") {
  //       event.preventDefault();
  //     }
  //     if (event.ctrlKey && event.shiftKey && event.key === "J") {
  //       event.preventDefault();
  //     }
  //     if (event.ctrlKey && event.key === "U") {
  //       event.preventDefault();
  //     }
  //     if (event.ctrlKey && event.shiftKey && event.key === "C") {
  //       event.preventDefault();
  //     }
  //   },
  // },
  // beforeDestroy() {
  //   document.removeEventListener("contextmenu", this.preventContextMenu);
  //   document.removeEventListener("keydown", this.preventKeyShortcuts);
  // },
};
</script>
<style>
.fontsize8px {
  font-size: 8px;
}
.fontsize9px {
  font-size: 9px;
}
.fontsize10px {
  font-size: 10px;
}
.fontsize11px {
  font-size: 11px !important;
}
.fontsize12px {
  font-size: 12px !important;
}
.fontsize13px {
  font-size: 13px !important;
}
.fontsize14px {
  font-size: 14px !important;
}
.fontsize15px {
  font-size: 15px !important;
}
.fontsize16px {
  font-size: 16px !important;
}
.fontsize17px {
  font-size: 17px !important;
}
.fontsize18px {
  font-size: 18px !important;
}
.fontsize19px {
  font-size: 19px !important;
}
.fontsize20px {
  font-size: 20px !important;
}
.fontsize21px {
  font-size: 21px !important;
}
.fontsize22px {
  font-size: 22px !important;
}
.fontsize23px {
  font-size: 23px !important;
}
.fontsize24px {
  font-size: 24px !important;
}
.fontsize25px {
  font-size: 25px !important;
}
.fontsize30px {
  font-size: 30px !important;
}
.fontsize35px {
  font-size: 35px !important;
}
.fontsize40px {
  font-size: 40px !important;
}
.fontsize80px {
  font-size: 80px !important;
}
.fontsize100px {
  font-size: 100px;
}
.v-input .v-label {
  font-size: 12px;
}
.field_height.v-text-field .v-input__control .v-input__slot {
  min-height: 12px !important;
  display: flex !important;
  align-items: center !important;
}
.field_label_size.v-input .v-label {
  font-size: 12px;
}
.v-select
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-select__selections {
  padding: 0 !important;
  min-height: 0 !important;
}

.v-select-list .v-list-item {
  min-height: 0 !important;
}

.v-select-list .v-list-item .v-list-item__content {
  padding: 14px 0 !important;
}
.image-upload-input {
  display: none;
  z-index: -9999;
}
.ImageRadius {
  border-radius: 80px !important;
  border-color: black 1px solid !important;
}
.my-dialog-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.BTNradius {
  border-radius: 15px !important;
}
.Defaultradius {
  border-radius: 5px !important;
}
.DialogAlign {
  align-self: flex-start !important;
}
.imgStyle {
  object-fit: cover;
  width: 250px;
  height: 200px;
}
.imgStyle:hover {
  box-shadow: 0 0 5px 5px rgba(0, 140, 186, 0.5) !important;
}
.hover-list-item {
  transition: background-color 0.3s ease !important;
}

.hover-list-item:hover {
  background-color: #6ba8e4 !important;
}

.icon {
  color: white;
  transition: color 0.3s ease !important;
}

.hover-list-item:hover .icon {
  color: #ffeb3b !important;
}

.title {
  color: white !important;
  transition: color 0.3s ease !important;
}

.hover-list-item:hover .title {
  color: #ffeb3b !important;
}
.btn-item {
  color: black !important;
  transition: background-color 0.3s ease !important;
}

.btn-item:hover {
  color: white !important;
  background-color: rgb(253, 54, 54) !important;
}
.white-divider {
  background-color: black !important;
}
.blink {
  animation: blinker 1s step-start infinite !important;
}

@keyframes blinker {
  50% {
    opacity: 0 !important;
  }
}

.DialogOpenFromTop {
  align-self: flex-start !important;
}
.RoundedCard {
  border-radius: 40px !important;
  width: 100px !important;
  height: 80px !important;
  background-color: #a8a9fe !important;
}
.imgclass {
  color: #ffeb3b !important;
  background-color: #a8a9fe !important;
}
.NumberAutocomplete {
  max-width: 20px !important;
  max-height: 20px !important;
}
.Imageradius {
  border-radius: 30px !important;
}
.CardBorderRadius {
  border-radius: 20px !important;
}
</style>
